import { render } from "./BrandsActions.vue?vue&type=template&id=79b3cf3a&scoped=true&lang=pug"
import script from "./BrandsActions.vue?vue&type=script&lang=js"
export * from "./BrandsActions.vue?vue&type=script&lang=js"

import "./BrandsActions.vue?vue&type=style&index=0&id=79b3cf3a&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b3cf3a"]])

export default __exports__